export default __webpack_public_path__ + "static/media/035-fish.08288a1b.svg";